import React, { useState } from 'react';
import { Layout } from '../Layout/Layout';
import JobTile from '../JobTile/JobTile';
import Loader from '../Loader/Loader';

export default function JobApproved(){
    return(
        <>
        <Layout>
            <JobTile title="Approved Jobs" type="3" />
        </Layout>
        </>
    )
}